// src/utils/clipboard.js
export const copyToClipboard = async (text) => {
    try {
      if (navigator.clipboard && window.isSecureContext) {
        await navigator.clipboard.writeText(text);
        return true; // success
      } else {
        // Fallback for older browsers/iOS
        const textarea = document.createElement("textarea");
        textarea.value = text;
        textarea.style.position = "fixed";  // avoid scrolling
        textarea.style.left = "-9999px";
        document.body.appendChild(textarea);
        textarea.focus();
        textarea.select();
  
        const success = document.execCommand("copy");
        document.body.removeChild(textarea);
        return success;
      }
    } catch (err) {
      console.error('Clipboard copy failed:', err);
      return false;
    }
  };
  
// Fulfillment Method (ERP-5042) comes back exactly as each platform stores it,
// which is not consistently human-readable. Lazada returns machine tokens
// ("pickup_in_store", "standard"), while Shopee returns "Doorstep Delivery
// (Next Day Doorstep Delivery COT EOD)" and TikTok "Shipped by seller".
//
// So only tidy the machine tokens. Any value already containing an uppercase
// letter is platform-formatted text and is left alone — blanket title-casing
// would damage it, turning "COT EOD" into "Cot Eod" and shifting "Shipped by
// seller" to "Shipped By Seller".
//
// Display only. The raw value is what is stored and what filter params are
// built from, so never feed the output of this into a query string.
export const formatFulfillmentMethod = (value) => {
  if (!value || typeof value !== "string") return value;
  if (/[A-Z]/.test(value)) return value;
  return value
    .split("_")
    .filter(Boolean)
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(" ");
};
